import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 重写go方法
Router.prototype.go = function () {
  this.isBack = true
  window.history.go(-1)
}

const Index = (resolve) => {
  import('@/components/index').then(medule => {
    resolve(medule)
  })
}

const Error = (resolve) => { // 错误页
  import('@/components/error/error').then(medule => {
    resolve(medule)
  })
}

const Login = (resolve) => { // 登录
  import('@/components/login/Login').then(medule => {
    resolve(medule)
  })
}

const registered = (resolve) => { // 注册
  import('@/components/login/registered').then(medule => {
    resolve(medule)
  })
}

const forgetPass = (resolve) => { // 找回密码
  import('@/components/login/forgetPass').then(medule => {
    resolve(medule)
  })
}

const Home = (resolve) => { // 首页
  import('@/components/home/index').then(medule => {
    resolve(medule)
  })
}

const ShopDetails = (resolve) => { // 商家详情
  import('@/components/home/shopDetails').then(medule => {
    resolve(medule)
  })
}

const shopDetailOn = (resolve) => { // 商家详情再进去 *)(*
  import('@/components/home/shopDetailOn').then(medule => {
    resolve(medule)
  })
}

const allContent = (resolve) => { // 全部评价页面
  import('@/components/home/allContent').then(medule => {
    resolve(medule)
  })
}

const pay = (resolve) => { // 支付
  import('@/components/common/pay').then(medule => {
    resolve(medule)
  })
}

const taskpay = (resolve) => { // 家百汇的支付
  import('@/components/common/taskpay').then(medule => {
    resolve(medule)
  })
}

const recharge = (resolve) => { // 充值
  import('@/components/common/recharge').then(medule => {
    resolve(medule)
  })
}

const search = (resolve) => { // 搜索
  import('@/components/common/search').then(medule => {
    resolve(medule)
  })
}

const Around = (resolve) => { // 生活圈首页
  import('@/components/around/index').then(medule => {
    resolve(medule)
  })
}

const searchShop = (resolve) => { // 搜索商家
  import('@/components/around/searchShop').then(medule => {
    resolve(medule)
  })
}

const czMoreSearchShop = (resolve) => { // 采集专区更多
  import('@/components/around/czMoreSearchShop').then(medule => {
    resolve(medule)
  })
}

const reservation = (resolve) => { // 预约商家
  import('@/components/around/reservation').then(medule => {
    resolve(medule)
  })
}

const reservationList = (resolve) => { // 预约商家列表
  import('@/components/around/reservationList').then(medule => {
    resolve(medule)
  })
}

const reservationDe = (resolve) => { // 预约商家列表
  import('@/components/around/reservationDe').then(medule => {
    resolve(medule)
  })
}

const receiptOrder = (resolve) => { // 收到转单
  import('@/components/my/receipt/receiptOrder').then(medule => {
    resolve(medule)
  })
}

const receiptOrderDe = (resolve) => { // 收到转单详情
  import('@/components/my/receipt/receiptOrderDe').then(medule => {
    resolve(medule)
  })
}

const Wallet = (resolve) => { // 我的钱包
  import('@/components/wallet/index').then(medule => {
    resolve(medule)
  })
}

const distributionResults = (resolve) => { // 我的分销业绩
  import('@/components/wallet/distributionResults').then(medule => {
    resolve(medule)
  })
}

const distributionProfit = (resolve) => { // 分销收益
  import('@/components/wallet/distributionProfit').then(medule => {
    resolve(medule)
  })
}

const orderIncome = (resolve) => { // 接单收入
  import('@/components/wallet/orderIncome').then(medule => {
    resolve(medule)
  })
}

const myAssets = (resolve) => { // 我的资产
  import('@/components/wallet/myAssets').then(medule => {
    resolve(medule)
  })
}

const myPoints = (resolve) => { // 我的积分
  import('@/components/wallet/myPoints').then(medule => {
    resolve(medule)
  })
}

const bankCard = (resolve) => { // 银行卡列表
  import('@/components/wallet/bankCard').then(medule => {
    resolve(medule)
  })
}

const addBank = (resolve) => { // 添加银行卡
  import('@/components/wallet/addBank').then(medule => {
    resolve(medule)
  })
}

const withdraw = (resolve) => { // 我的钱包
  import('@/components/wallet/withdraw').then(medule => {
    resolve(medule)
  })
}

const bills = (resolve) => { // 账单
  import('@/components/wallet/bills').then(medule => {
    resolve(medule)
  })
}

const getRich = (resolve) => { // 致富记录
  import('@/components/wallet/getRich').then(medule => {
    resolve(medule)
  })
}

const Mall = (resolve) => { // 商城首页
  import('@/components/mall/index').then(medule => {
    resolve(medule)
  })
}

const drawBill = (resolve) => { // 开发票
  import('@/components/mall/drawBill').then(medule => {
    resolve(medule)
  })
}

const spikeList = (resolve) => { // 秒杀列表
  import('@/components/mall/spikeList').then(medule => {
    resolve(medule)
  })
}

const goodsClassify = (resolve) => { // 分类列表
  import('@/components/mall/goodsClassify').then(medule => {
    resolve(medule)
  })
}

const goodsDe = (resolve) => { // 商品详情
  import('@/components/mall/goodsDe').then(medule => {
    resolve(medule)
  })
}

const confirmOrder = (resolve) => { // 确认订单
  import('@/components/mall/confirmOrder').then(medule => {
    resolve(medule)
  })
}

const shoppingCart = (resolve) => { // 购物车
  import('@/components/mall/shoppingCart').then(medule => {
    resolve(medule)
  })
}

const myOrder = (resolve) => { // 我的订单
  import('@/components/mall/myOrder').then(medule => {
    resolve(medule)
  })
}

const orderDe = (resolve) => { // 订单详情
  import('@/components/mall/orderDe').then(medule => {
    resolve(medule)
  })
}

const logistics = (resolve) => { // 物流详情
  import('@/components/mall/logistics').then(medule => {
    resolve(medule)
  })
}

const returnsGoods = (resolve) => { // 申请退换货
  import('@/components/mall/returnsGoods').then(medule => {
    resolve(medule)
  })
}

const changeGoods = (resolve) => { // 退换货列表
  import('@/components/mall/changeGoods').then(medule => {
    resolve(medule)
  })
}

const changeGoodsDp = (resolve) => { // 申请退换货详情页
  import('@/components/mall/changeGoodsDp').then(medule => {
    resolve(medule)
  })
}

const assess = (resolve) => { // 评价商品
  import('@/components/mall/assess').then(medule => {
    resolve(medule)
  })
}

const moreClassify = (resolve) => { // 更多分类页面
  import('@/components/mall/moreClassify').then(medule => {
    resolve(medule)
  })
}

const specialArea = (resolve) => { // 特产专区店铺列表
  import('@/components/mall/specialArea').then(medule => {
    resolve(medule)
  })
}

const My = (resolve) => { // 我的
  import('@/components/my/index').then(medule => {
    resolve(medule)
  })
}

const MyCertification = (resolve) => { // 我的认证
  import('@/components/my/myCertification/index').then(medule => {
    resolve(medule)
  })
}

const installCertification = (resolve) => { // 安装认证
  import('@/components/my/myCertification/installCertification').then(medule => {
    resolve(medule)
  })
}

const installCertificationDe = (resolve) => { // 安装认证-已通过
  import('@/components/my/myCertification/installCertificationDe').then(medule => {
    resolve(medule)
  })
}

const cargoCertification = (resolve) => { // 拉货认证
  import('@/components/my/myCertification/cargoCertification').then(medule => {
    resolve(medule)
  })
}

const cargoCertificationDe = (resolve) => { // 拉货认证-已通过
  import('@/components/my/myCertification/cargoCertificationDe').then(medule => {
    resolve(medule)
  })
}

const myResume = (resolve) => { // 我的简历
  import('@/components/my/myResume').then(medule => {
    resolve(medule)
  })
}

const collection = (resolve) => { // 我的收藏(已废弃)
  import('@/components/my/collection').then(medule => {
    resolve(medule)
  })
}

const hideGoods = (resolve) => { // 收藏商品
  import('@/components/my/hideGoods').then(medule => {
    resolve(medule)
  })
}

const hideShops = (resolve) => { // 收藏店铺
  import('@/components/my/hideShops').then(medule => {
    resolve(medule)
  })
}

const personalData = (resolve) => { // 个人资料（废弃）
  import('@/components/my/personal/personalData').then(medule => {
    resolve(medule)
  })
}

const myInformation = (resolve) => { // 个人资料
  import('@/components/my/personal/myInformation').then(medule => {
    resolve(medule)
  })
}

const accountsSecurity = (resolve) => { // 账户与安全
  import('@/components/my/personal/accountsSecurity').then(medule => {
    resolve(medule)
  })
}

const editPhone = (resolve) => { // 绑定手机号
  import('@/components/my/personal/editPhone').then(medule => {
    resolve(medule)
  })
}

const editPersonalData = (resolve) => { // 编辑个人资料
  import('@/components/my/personal/editPersonalData').then(medule => {
    resolve(medule)
  })
}

const editGender = (resolve) => { // 设置性别
  import('@/components/my/personal/editGender').then(medule => {
    resolve(medule)
  })
}

const editUsername = (resolve) => { // 更改用户名
  import('@/components/my/personal/editUsername').then(medule => {
    resolve(medule)
  })
}

const moreData = (resolve) => { // 更多资料
  import('@/components/my/personal/moreData').then(medule => {
    resolve(medule)
  })
}

const editMoreData = (resolve) => { // 完善更多资料
  import('@/components/my/personal/editMoreData').then(medule => {
    resolve(medule)
  })
}

const set = (resolve) => { // 设置的首页
  import('@/components/my/set/index').then(medule => {
    resolve(medule)
  })
}

const editPassword = (resolve) => { // 设置密码 登录密码，支付密码公用
  import('@/components/my/set/editPassword').then(medule => {
    resolve(medule)
  })
}

const about = (resolve) => { // 关于我们
  import('@/components/my/set/about').then(medule => {
    resolve(medule)
  })
}

const feedback = (resolve) => { // 投诉
  import('@/components/my/set/feedback').then(medule => {
    resolve(medule)
  })
}

const ruralSystem = (resolve) => { // 乡村通知
  import('@/components/my/set/ruralSystem').then(medule => {
    resolve(medule)
  })
}

const system = (resolve) => { // 系统消息
  import('@/components/my/system/index').then(medule => {
    resolve(medule)
  })
}

const myAddr = (resolve) => { // 我的地址
  import('@/components/my/myAddr').then(medule => {
    resolve(medule)
  })
}

const settleIn = (resolve) => { // 申请入驻首页
  import('@/components/my/settleIn/index').then(medule => {
    resolve(medule)
  })
}

const indexR = (resolve) => { // 入驻
  import('@/components/my/settleIn/settleInR/indexR').then(medule => {
    resolve(medule)
  })
}

const settleOne = (resolve) => { // 企业-入驻1
  import('@/components/my/settleIn/settleInR/settleOne').then(medule => {
    resolve(medule)
  })
}

const settleTwo = (resolve) => { // 企业-入驻2
  import('@/components/my/settleIn/settleInR/settleTwo').then(medule => {
    resolve(medule)
  })
}

const settleSthree = (resolve) => { // 企业-入驻3
  import('@/components/my/settleIn/settleInR/settleSthree').then(medule => {
    resolve(medule)
  })
}

const moveOne = (resolve) => { // 个人-入驻1
  import('@/components/my/settleIn/settleInR/moveOne').then(medule => {
    resolve(medule)
  })
}

const moveTwo = (resolve) => { // 个人-入驻2
  import('@/components/my/settleIn/settleInR/moveTwo').then(medule => {
    resolve(medule)
  })
}

const moveSthree = (resolve) => { // 个人-入驻3
  import('@/components/my/settleIn/settleInR/moveSthree').then(medule => {
    resolve(medule)
  })
}

const auditDetailsPage = (resolve) => { // 入驻详情页
  import('@/components/my/settleIn/settleInR/auditDetailsPage').then(medule => {
    resolve(medule)
  })
}

const businessClassify = (resolve) => { // 经营分类
  import('@/components/my/settleIn/settleInR/businessClassify').then(medule => {
    resolve(medule)
  })
}

const serviceAgreement = (resolve) => { // 入驻-服务协议
  import('@/components/my/settleIn/serviceAgreement').then(medule => {
    resolve(medule)
  })
}

const chooseMerchantType = (resolve) => { // 入驻-选择商家类型
  import('@/components/my/settleIn/chooseMerchantType').then(medule => {
    resolve(medule)
  })
}

const propertySettle = (resolve) => { // 申请入驻 小区物业
  import('@/components/my/settleIn/property').then(medule => {
    resolve(medule)
  })
}

const community = (resolve) => { // 申请入驻 小区
  import('@/components/my/settleIn/community').then(medule => {
    resolve(medule)
  })
}
const agentsSettle = (resolve) => { // 申请入驻 代理商
  import('@/components/my/settleIn/agents').then(medule => {
    resolve(medule)
  })
}

const ruralSettle = (resolve) => { // 申请入驻 乡村
  import('@/components/my/settleIn/rural').then(medule => {
    resolve(medule)
  })
}

const shopSetIn = (resolve) => { // 申请入驻 商家
  import('@/components/my/settleIn/shopSetIn').then(medule => {
    resolve(medule)
  })
}

const rotaryTable = (resolve) => { // 转盘
  import('@/components/rotaryTable').then(medule => {
    resolve(medule)
  })
}

const recommend = (resolve) => { // 我的推荐
  import('@/components/my/recommend/index').then(medule => {
    resolve(medule)
  })
}

const subordinate = (resolve) => { // 我的下级
  import('@/components/my/recommend/subordinate').then(medule => {
    resolve(medule)
  })
}

const yssm = (resolve) => { // 我的下级
  import('@/components/my/yssm').then(medule => {
    resolve(medule)
  })
}

const poster = (resolve) => { // 海报
  import('@/components/my/recommend/poster').then(medule => {
    resolve(medule)
  })
}

const headlines = (resolve) => { // 社会头条
  import('@/components/home/headlines').then(medule => {
    resolve(medule)
  })
}

const spikeGoodsDe = (resolve) => { // 秒杀 商品详情
  import('@/components/mall/spike/goodsDe').then(medule => {
    resolve(medule)
  })
}

// 家百汇
const taskIndex = (resolve) => { // 首页 家百汇
  import('@/components/task/index').then(medule => {
    resolve(medule)
  })
}

const releaseTask = (resolve) => { // 发布任务
  import('@/components/task/customer/releaseTask').then(medule => {
    resolve(medule)
  })
}

const releaseTaskHandling = (resolve) => { // 发布搬运
  import('@/components/task/customer/releaseTaskHandling').then(medule => {
    resolve(medule)
  })
}

const taskList = (resolve) => { // 客户订单列表
  import('@/components/task/worker/taskList').then(medule => {
    resolve(medule)
  })
}

const recyclingList = (resolve) => { // 家电回收列表
  import('@/components/task/customer/recyclingList').then(medule => {
    resolve(medule)
  })
}

const taskOrderList = (resolve) => { // 我发布的订单列表
  import('@/components/task/customer/taskOrderList').then(medule => {
    resolve(medule)
  })
}

const customerOrderDetail = (resolve) => { // 我发布的订单详情
  import('@/components/task/customer/orderDetail').then(medule => {
    resolve(medule)
  })
}

const biddingList = (resolve) => { // 竞价列表
  import('@/components/task/customer/biddingList').then(medule => {
    resolve(medule)
  })
}

const workerDetail = (resolve) => { // 师傅详情
  import('@/components/task/customer/workerDetail').then(medule => {
    resolve(medule)
  })
}

const accepting = (resolve) => { // 验收详情
  import('@/components/task/customer/accepting').then(medule => {
    resolve(medule)
  })
}

const attachOrder = (resolve) => { // 添加附加订单
  import('@/components/task/customer/attachOrder').then(medule => {
    resolve(medule)
  })
}

const commentOrder = (resolve) => { // 评价订单
  import('@/components/task/customer/commentOrder').then(medule => {
    resolve(medule)
  })
}

const changeOrder = (resolve) => { // 转单
  import('@/components/task/worker/changeOrder').then(medule => {
    resolve(medule)
  })
}

const finshed = (resolve) => { // 完工情况-提交
  import('@/components/task/worker/finshed').then(medule => {
    resolve(medule)
  })
}

const receiveTaskOrderList = (resolve) => { // 我接收的订单列表
  import('@/components/task/worker/receiveTaskOrderList').then(medule => {
    resolve(medule)
  })
}

const workerShopOederDetail = (resolve) => { // 接收的订单详情 --- 还未进行报价的
  import('@/components/task/worker/shopOederDetail').then(medule => {
    resolve(medule)
  })
}

const workerQuote = (resolve) => { // 接单报价/修改报价
  import('@/components/task/worker/workerQuote').then(medule => {
    resolve(medule)
  })
}

const workerOrderDetail = (resolve) => { // 我接收的订单详情
  import('@/components/task/worker/orderDetail').then(medule => {
    resolve(medule)
  })
}

export default new Router({
  routes: [
    {
      path: '*',
      name: '*',
      component: Error
    },
    {
      path: '/',
      name: 'Index',
      component: Index,
      children: [
        {
          path: 'rotaryTable',
          name: 'rotaryTable',
          component: rotaryTable
        },
        {
          path: '/Login',
          name: 'Login',
          component: Login,
          meta: {keepAlive: false}
        },
        {
          path: '/registered',
          name: 'registered',
          component: registered,
          meta: {keepAlive: false}
        },
        {
          path: '/forgetPass',
          name: 'forgetPass',
          component: forgetPass,
          meta: {keepAlive: false}
        },
        {
          path: '/ShopDetails',
          name: 'ShopDetails',
          component: ShopDetails,
          meta: {keepAlive: false}
        },
        {
          path: '/shopDetailOn',
          name: 'shopDetailOn',
          component: shopDetailOn,
          meta: {keepAlive: false}
        },
        {
          path: '/allContent',
          name: 'allContent',
          component: allContent,
          meta: {keepAlive: false}
        },
        {
          path: '/pay',
          name: 'pay',
          component: pay,
          meta: {keepAlive: false, isNeedLogin: true}
        },
        {
          path: '/taskpay',
          name: 'taskpay',
          component: taskpay,
          meta: {keepAlive: false, isNeedLogin: true}
        },
        {
          path: '/recharge',
          name: 'recharge',
          component: recharge,
          meta: {keepAlive: false, isNeedLogin: true}
        },
        {
          path: '/search',
          name: 'search',
          component: search,
          meta: {keepAlive: false}
        },
        {
          path: '',
          name: 'Home',
          component: Home,
          meta: {keepAlive: true, footShow: true}
        },
        {
          path: '/Around',
          name: 'Around',
          component: Around,
          meta: {keepAlive: true, footShow: true}
        },
        {
          path: '/searchShop',
          name: 'searchShop',
          component: searchShop,
          meta: {keepAlive: false, footShow: false}
        },
        {
          path: '/czMoreSearchShop',
          name: 'czMoreSearchShop',
          component: czMoreSearchShop,
          meta: {keepAlive: false, footShow: false}
        },
        {
          path: '/reservation',
          name: 'reservation',
          component: reservation,
          meta: {keepAlive: false, footShow: false}
        },
        {
          path: '/reservationList',
          name: 'reservationList',
          component: reservationList,
          meta: {keepAlive: false, footShow: false}
        },
        {
          path: '/reservationDe',
          name: 'reservationDe',
          component: reservationDe,
          meta: {keepAlive: false, footShow: false}
        },
        {
          path: '/receiptOrder',
          name: 'receiptOrder',
          component: receiptOrder,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/receiptOrderDe',
          name: 'receiptOrderDe',
          component: receiptOrderDe,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/Wallet',
          name: 'Wallet',
          component: Wallet,
          meta: {keepAlive: false, footShow: true, isNeedLogin: true}
        },
        {
          path: '/distributionResults',
          name: 'distributionResults',
          component: distributionResults,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/distributionProfit',
          name: 'distributionProfit',
          component: distributionProfit,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/orderIncome',
          name: 'orderIncome',
          component: orderIncome,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/bankCard',
          name: 'bankCard',
          component: bankCard,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/addBank',
          name: 'addBank',
          component: addBank,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/withdraw',
          name: 'withdraw',
          component: withdraw,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/bills',
          name: 'bills',
          component: bills,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/getRich',
          name: 'getRich',
          component: getRich,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/Mall',
          name: 'Mall',
          component: Mall,
          meta: {keepAlive: true, footShow: true}
        },
        {
          path: '/drawBill',
          name: 'drawBill',
          component: drawBill,
          meta: {keepAlive: false, footShow: false}
        },
        {
          path: '/spikeList',
          name: 'spikeList',
          component: spikeList,
          meta: {keepAlive: false, footShow: false}
        },
        {
          path: '/goodsDe',
          name: 'goodsDe',
          component: goodsDe,
          meta: {keepAlive: false, footShow: false}
        },
        {
          path: '/goodsClassify',
          name: 'goodsClassify',
          component: goodsClassify,
          meta: {keepAlive: false, footShow: false}
        },
        {
          path: '/confirmOrder',
          name: 'confirmOrder',
          component: confirmOrder,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/shoppingCart',
          name: 'shoppingCart',
          component: shoppingCart,
          meta: {keepAlive: false, footShow: true, isNeedLogin: true}
        },
        {
          path: '/myOrder',
          name: 'myOrder',
          component: myOrder,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/orderDe',
          name: 'orderDe',
          component: orderDe,
          meta: {keepAlive: false, footShow: false}
        },
        {
          path: '/logistics',
          name: 'logistics',
          component: logistics,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/returnsGoods',
          name: 'returnsGoods',
          component: returnsGoods,
          meta: {keepAlive: false, footShow: false}
        },
        {
          path: '/changeGoods',
          name: 'changeGoods',
          component: changeGoods,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/changeGoodsDp',
          name: 'changeGoodsDp',
          component: changeGoodsDp,
          meta: {keepAlive: false, footShow: false}
        },
        {
          path: '/assess',
          name: 'assess',
          component: assess,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/moreClassify',
          name: 'moreClassify',
          component: moreClassify,
          meta: {keepAlive: false, footShow: false}
        },
        {
          path: '/specialArea',
          name: 'specialArea',
          component: specialArea,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/my',
          name: 'My',
          component: My,
          meta: {keepAlive: false, footShow: true}
        },
        {
          path: '/MyCertification',
          name: 'MyCertification',
          component: MyCertification,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/installCertification',
          name: 'installCertification',
          component: installCertification,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/installCertificationDe',
          name: 'installCertificationDe',
          component: installCertificationDe,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/myResume',
          name: 'myResume',
          component: myResume,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/cargoCertification',
          name: 'cargoCertification',
          component: cargoCertification,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/cargoCertificationDe',
          name: 'cargoCertificationDe',
          component: cargoCertificationDe,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/collection',
          name: 'collection',
          component: collection,
          meta: {keepAlive: true, footShow: false, isNeedLogin: true}
        },
        {
          path: '/hideGoods',
          name: 'hideGoods',
          component: hideGoods,
          meta: {keepAlive: true, footShow: false, isNeedLogin: true}
        },
        {
          path: '/hideShops',
          name: 'hideShops',
          component: hideShops,
          meta: {keepAlive: true, footShow: false, isNeedLogin: true}
        },
        {
          path: '/accountsSecurity',
          name: 'accountsSecurity',
          component: accountsSecurity,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/myInformation',
          name: 'myInformation',
          component: myInformation,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/personalData',
          name: 'personalData',
          component: personalData,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/editPhone',
          name: 'editPhone',
          component: editPhone,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/editPersonalData',
          name: 'editPersonalData',
          component: editPersonalData,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/editGender',
          name: 'editGender',
          component: editGender,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/editUsername',
          name: 'editUsername',
          component: editUsername,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/moreData',
          name: 'moreData',
          component: moreData,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/editMoreData',
          name: 'editMoreData',
          component: editMoreData,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/set',
          name: 'set',
          component: set,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/editPassword',
          name: 'editPassword',
          component: editPassword,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/about',
          name: 'about',
          component: about,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/feedback',
          name: 'feedback',
          component: feedback,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/ruralSystem',
          name: 'ruralSystem',
          component: ruralSystem,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/system',
          name: 'system',
          component: system,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/myAddr',
          name: 'myAddr',
          component: myAddr,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/settleIn',
          name: 'settleIn',
          component: settleIn,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/indexR',
          name: 'indexR',
          component: indexR,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true},
          children: [
            {
              path: '/indexR/settleOne',
              name: 'settleOne',
              component: settleOne,
              meta: {keepAlive: false, footShow: false, isNeedLogin: true}
            },
            {
              path: '/indexR/settleTwo',
              name: 'settleTwo',
              component: settleTwo,
              meta: {keepAlive: false, footShow: false, isNeedLogin: true}
            },
            {
              path: '/indexR/settleSthree',
              name: 'settleSthree',
              component: settleSthree,
              meta: {keepAlive: false, footShow: false, isNeedLogin: true}
            },
            {
              path: '/indexR/moveOne',
              name: 'moveOne',
              component: moveOne,
              meta: {keepAlive: false, footShow: false, isNeedLogin: true}
            },
            {
              path: '/indexR/moveTwo',
              name: 'moveTwo',
              component: moveTwo,
              meta: {keepAlive: false, footShow: false, isNeedLogin: true}
            },
            {
              path: '/indexR/moveSthree',
              name: 'moveSthree',
              component: moveSthree,
              meta: {keepAlive: false, footShow: false, isNeedLogin: true}
            },
            {
              path: '/indexR/auditDetailsPage',
              name: 'auditDetailsPage',
              component: auditDetailsPage,
              meta: {keepAlive: false, footShow: false, isNeedLogin: true}
            },
            {
              path: '/indexR/businessClassify',
              name: 'businessClassify',
              component: businessClassify,
              meta: {keepAlive: false, footShow: false, isNeedLogin: true}
            }
          ]
        },
        {
          path: '/serviceAgreement',
          name: 'serviceAgreement',
          component: serviceAgreement,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/chooseMerchantType',
          name: 'chooseMerchantType',
          component: chooseMerchantType,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/propertySettle',
          name: 'propertySettle',
          component: propertySettle,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/community',
          name: 'community',
          component: community,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/agentsSettle',
          name: 'agentsSettle',
          component: agentsSettle,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/ruralSettle',
          name: 'ruralSettle',
          component: ruralSettle,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/shopSetIn',
          name: 'shopSetIn',
          component: shopSetIn,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/recommend',
          name: 'recommend',
          component: recommend,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/subordinate',
          name: 'subordinate',
          component: subordinate,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/yssm',
          name: 'yssm',
          component: yssm,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/poster',
          name: 'poster',
          component: poster,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/headlines',
          name: 'headlines',
          component: headlines,
          meta: {keepAlive: false, footShow: false, isNeedLogin: false}
        },
        {
          path: '/spikeGoodsDe',
          name: 'spikeGoodsDe',
          component: spikeGoodsDe,
          meta: {keepAlive: false, footShow: false, isNeedLogin: false}
        },
        {
          path: '/myAssets',
          name: 'myAssets',
          component: myAssets,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/myPoints',
          name: 'myPoints',
          component: myPoints,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/TaskIndex',
          name: 'TaskIndex',
          component: taskIndex,
          meta: {keepAlive: true, footShow: true, isNeedLogin: false}
        },
        {
          path: '/releaseTask',
          name: 'releaseTask',
          component: releaseTask,
          meta: {keepAlive: false, footShow: false, isNeedLogin: false}
        },
        {
          path: '/releaseTaskHandling',
          name: 'releaseTaskHandling',
          component: releaseTaskHandling,
          meta: {keepAlive: false, footShow: false, isNeedLogin: false}
        },
        {
          path: '/taskList',
          name: 'taskList',
          component: taskList,
          meta: {keepAlive: false, footShow: false, isNeedLogin: false}
        },
        {
          path: '/recyclingList',
          name: 'recyclingList',
          component: recyclingList,
          meta: {keepAlive: false, footShow: false, isNeedLogin: false}
        },
        {
          path: '/taskOrderList',
          name: 'taskOrderList',
          component: taskOrderList,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/customerOrderDetail',
          name: 'customerOrderDetail',
          component: customerOrderDetail,
          meta: {keepAlive: false, footShow: false, isNeedLogin: false}
        },
        {
          path: '/biddingList',
          name: 'biddingList',
          component: biddingList,
          meta: {keepAlive: false, footShow: false, isNeedLogin: false}
        },
        {
          path: '/workerDetail',
          name: 'workerDetail',
          component: workerDetail,
          meta: {keepAlive: false, footShow: false, isNeedLogin: false}
        },
        {
          path: '/accepting',
          name: 'accepting',
          component: accepting,
          meta: {keepAlive: false, footShow: false, isNeedLogin: false}
        },
        {
          path: '/attachOrder',
          name: 'attachOrder',
          component: attachOrder,
          meta: {keepAlive: false, footShow: false, isNeedLogin: false}
        },
        {
          path: '/commentOrder',
          name: 'commentOrder',
          component: commentOrder,
          meta: {keepAlive: false, footShow: false, isNeedLogin: false}
        },
        {
          path: '/changeOrder',
          name: 'changeOrder',
          component: changeOrder,
          meta: {keepAlive: false, footShow: false, isNeedLogin: false}
        },
        {
          path: '/finshed',
          name: 'finshed',
          component: finshed,
          meta: {keepAlive: false, footShow: false, isNeedLogin: false}
        },
        {
          path: '/receiveTaskOrderList',
          name: 'receiveTaskOrderList',
          component: receiveTaskOrderList,
          meta: {keepAlive: false, footShow: false, isNeedLogin: true}
        },
        {
          path: '/workerShopOederDetail',
          name: 'workerShopOederDetail',
          component: workerShopOederDetail,
          meta: {keepAlive: false, footShow: false, isNeedLogin: false}
        },
        {
          path: '/workerQuote',
          name: 'workerQuote',
          component: workerQuote,
          meta: {keepAlive: false, footShow: false, isNeedLogin: false}
        },
        {
          path: '/workerOrderDetail',
          name: 'workerOrderDetail',
          component: workerOrderDetail,
          meta: {keepAlive: false, footShow: false, isNeedLogin: false}
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js